export default {
	"share.FailedToGetInformation": "获取信息失败",
	"share.generatingPoster": "正在生成海报",
	"share.LongPressThePictureToShare": "长按图片进行分享",
	"share.LimitPrice": "限购价",
	"share.LimitedGift": "限量赠"
}